import styled from "styled-components"
import InputPhoneFormat from "../../shared/input/new/InputPhoneFormat"
import Btn from "../../shared/button/Btn"
import { useEffect, useState } from "react"
import PageTopTitle from "../../shared/PageTopTitle"
import { useDispatch } from "react-redux"
import { showModal } from "../../../features/modal/modalSlice"
import { useSelector } from "react-redux"
import SmallSpinner from "../../shared/spinners/SmallSpinner"
import { getJobListDriverData, jobListPhoneNumberOrNameQuery, jobListPhoneNumberQuery, regularDriverPhoneNumberQuery, setJobListPhoneNumberOrNameQueryResults, setRegularDriverPhoneNumberQueryStatus } from "../../../features/driversVehicles/driversVehiclesSlice"
import InputText from "../../shared/input/new/InputText"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: 750px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 25px 0;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 30px;

        .query-container{

            display: flex;
            gap: 15px;
            padding: 20px 40px;

            .err-text{
                color: var(--color-main);
                font-size: 13px;
                font-weight: var(--font-weight-md);
                padding-top: 10px;
            }

            .res-container{
                width: 320px;
                height: auto;
                max-height: 300px;
                overflow: auto;
                border: 1px solid ${({theme}) => theme.mainBorderColor};
                display: flex;
                flex-direction: column;

                .res-item{
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                    font-weight: 600;
                    color: ${({theme}) => theme.mainTextColor};
                    padding: 10px;
                    cursor: pointer;

                }
            }
        }

        .btn-container{
            display: flex;
            gap: 30px;
        }

    }
`

const AddJobListRegularVehiclePhoneNumberQueryModal = () => {

    const dispatch = useDispatch()

    const [typingTimeout, setTypingTimeout] = useState(null)

    const {isLoadingRegularDriverPhoneNumberQuery, jobListPhoneNumberOrNameQueryResults} = useSelector(state => state.driversVehicles)

    const [value, setValue] = useState("")

    // useEffect(() => {
    //     if(isSubmit){
    //         if(phoneNumber?.slice(2).length !== 10 || phoneNumber?.slice(2)[0] !== "5"){
    //             setIsError(true)
    //         }
    //         else{
    //             setIsError(false)
    //         }
    //     }
    // },[isSubmit, phoneNumber])

    useEffect(() => {
        return () => {
            dispatch(setJobListPhoneNumberOrNameQueryResults([]))
        }
    },[])


        const handleReq = (value) => {
            
            // Eğer daha önce bir timeout ayarlanmışsa iptal et
            if (typingTimeout) {
                clearTimeout(typingTimeout);
                }
            // Yeni bir timeout ayarla
            const timeout = setTimeout(() => {
                if(value.length > 3){
                    dispatch(jobListPhoneNumberOrNameQuery(value.replace(/^0+/, '')))
                }
            }, 1000); // 1 saniye (1000 ms)

            setTypingTimeout(timeout);
        }

  return (
    <Container>
        <div className="modal">
            <PageTopTitle isDiffPage title={"Sıraya Araç Ekle"}/>
            <div className="query-container">
                <div>
                    <InputText data={value} setData={(e) => {setValue(e.target.value); handleReq(e.target.value)}} labelText="Telefon Numarası Veya İsim Girin" inputWidth={"320px"} name={"value"}/>
                    <div className="res-container">
                        {
                            jobListPhoneNumberOrNameQueryResults.map(item => (
                                <div className="res-item" onClick={() => dispatch(getJobListDriverData(item.phoneNumber))}>{item.phoneNumber} - {item.name}</div>
                            ))
                        }
                    </div>
                </div>
                {/* <Btn bgColor="var(--color-main)" color="#fff" width={"100px"} handleClick={handleSubmit} >{isLoadingRegularDriverPhoneNumberQuery ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Sorgula"}</Btn> */}
            </div>

            <div className="btn-container">
                <Btn bgColor="transparent" color="var(--color-main)" width={"140px"} handleClick={() => dispatch(showModal(null))}>Vazgeç</Btn>
            </div>
        </div>
    </Container>
  )
}

export default AddJobListRegularVehiclePhoneNumberQueryModal